import React from 'react'
import styled from 'styled-components'
import { roundUpTo } from '@sketch/utils'
import { rgbTo } from '../utils'
import { ColorFormat } from '../../../../../../types'

export const ScreenReaderOnly = styled.div`
  display: none;
`

const FormatDetail = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

interface FormattedColorValueProps {
  format: ColorFormat
  color: {
    red: number
    green: number
    blue: number
    alpha?: number
  }
}

export const FormattedColorValue = ({
  format,
  color,
}: FormattedColorValueProps) => {
  const roundedAlpha = roundUpTo(color.alpha || 1, 0)
  const roundedAlphaPercentage = roundUpTo((color.alpha || 1) * 100, 0)

  switch (format) {
    case ColorFormat.HEX:
      return (
        <>
          <div aria-hidden>
            <FormatDetail>#</FormatDetail>
            {rgbTo(ColorFormat.HEX, color).substring(1, 7)}{' '}
            <FormatDetail>{roundedAlphaPercentage}%</FormatDetail>
          </div>
          <ScreenReaderOnly>{rgbTo(ColorFormat.HEX, color)}</ScreenReaderOnly>
        </>
      )
    case ColorFormat.RGB: {
      const rgbaString = `rgba(${color.red},${color.green},${color.blue},${roundedAlpha})`

      return (
        <>
          <div aria-hidden>
            <FormatDetail>rgba(</FormatDetail>
            {color.red}
            <FormatDetail>,</FormatDetail> {color.green}
            <FormatDetail>,</FormatDetail> {color.blue}
            <FormatDetail>,</FormatDetail> {roundedAlpha}
            <FormatDetail>)</FormatDetail>
          </div>
          <ScreenReaderOnly>{rgbaString}</ScreenReaderOnly>
        </>
      )
    }
    case ColorFormat.HSL: {
      const hsl = rgbTo(ColorFormat.HSL, color)
      const hslOutput = hsl.substring(5, hsl.length - 1).split(',')

      return (
        <>
          <div aria-hidden>
            <FormatDetail>hsl(</FormatDetail>
            {hslOutput.map((value, index) => (
              <React.Fragment key={index}>
                {value}
                {index < hslOutput.length - 1 ? (
                  <FormatDetail>,</FormatDetail>
                ) : null}
              </React.Fragment>
            ))}
            <FormatDetail>)</FormatDetail>
          </div>
          <ScreenReaderOnly>{hsl}</ScreenReaderOnly>
        </>
      )
    }

    case ColorFormat.OBJC_NSCOLOR:
      return <>{rgbTo(ColorFormat.OBJC_NSCOLOR, color)}</>

    case ColorFormat.OBJC_UICOLOR:
      return <>{rgbTo(ColorFormat.OBJC_UICOLOR, color)}</>
    case ColorFormat.SWIFT_NSCOLOR:
      return <>{rgbTo(ColorFormat.OBJC_NSCOLOR, color)}</>
    case ColorFormat.SWIFT_UICOLOR:
      return <>{rgbTo(ColorFormat.OBJC_UICOLOR, color)}</>
    default:
      return null
  }
}
